import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

interface LegalPageLayoutProps {
  title: string;
  lastUpdated: string;
  children: React.ReactNode;
}

const LegalPageLayout: React.FC<LegalPageLayoutProps> = ({ title, lastUpdated, children }) => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="font-sans bg-background text-foreground w-full">
      <div className="max-w-[900px] mx-auto px-5 sm:px-8 py-8 sm:py-12">
        <button
          onClick={() => navigate(-1)}
          className="bg-transparent border-none text-muted-foreground text-base cursor-pointer mb-6 flex items-center gap-2 hover:text-foreground transition-colors"
        >
          &larr; Back
        </button>
        <h1 className="font-display text-3xl sm:text-4xl font-bold text-primary mb-2">{title}</h1>
        <p className="text-muted-foreground mb-8 text-sm">Last Updated: {lastUpdated}</p>
        <div className="bg-card border border-border rounded-2xl shadow-lg p-6 sm:p-10 legal-content">
          {children}
        </div>
      </div>
    </div>
  );
};

export default LegalPageLayout;
